var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{ref:"headingWrapper",staticClass:"heading-animated"},_vm._l((_vm.lines),function(line,index){return _c('span',{directives:[{name:"in-viewport",rawName:"v-in-viewport"}],key:index,ref:"headingLine",refInFor:true,staticClass:"heading-animated__line"},[_vm._v(_vm._s(line))])}))}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57322eaa","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeadingAnimated.vue
// module id = null
// module chunks = 